import React, { useState } from "react";
import { Box, TextField, Typography, Button, Divider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { Stack } from "@mui/material"; // asegúrate de importar Stack

const ProposalFilterSidebar = ({ filters, setFilters, onApply, onReset }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (name, date) => {
    if (!date || date === null || date === "") {
      // Elimina el filtro del estado si se borra la fecha
      setFilters((prev) => {
        const updated = { ...prev };
        delete updated[name];
        return updated;
      });
    } else {
      setFilters((prev) => ({
        ...prev,
        [name]: dayjs(date).format("YYYY-MM-DD"),
      }));
    }
  };

  ProposalFilterSidebar.propTypes = {
    filters: PropTypes.object.isRequired,
    setFilters: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
  };

  return (
    <Box
      sx={{
        width: 300, // antes: 300
        padding: 2,
        borderRight: "1px solid #ccc",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Box mb={2}>
        <Typography variant="h6" gutterBottom>
          Advanced search
        </Typography>
      </Box>

      <Stack spacing={2}>
        <TextField
          label="Code"
          name="code"
          value={filters.code || ""}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="Title"
          name="title"
          value={filters.title || ""}
          onChange={handleChange}
          fullWidth
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="From date"
            value={filters.submission_date__gte ? dayjs(filters.submission_date__gte) : null}
            onChange={(date) => handleDateChange("submission_date__gte", date)}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />

          <DatePicker
            label="To date"
            value={filters.submission_date__lte ? dayjs(filters.submission_date__lte) : null}
            onChange={(date) => handleDateChange("submission_date__lte", date)}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>

        <TextField
          label="Institution"
          name="institution"
          value={filters.institution || ""}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="Infrastructure"
          name="infrastructure"
          value={filters.infrastructure || ""}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="Beamlines"
          name="beamline"
          value={filters.beamline || ""}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="Techniques"
          name="technique"
          value={filters.technique || ""}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="PI"
          name="pi"
          value={filters.pi || ""}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="Researchers"
          name="researcher"
          value={filters.researcher || ""}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="Projects"
          name="project"
          value={filters.project || ""}
          onChange={handleChange}
          fullWidth
        />
      </Stack>

      <Divider sx={{ my: 3 }} />

      <Box display="flex" justifyContent="space-between">
        <Button variant="contained" color="primary" onClick={onApply}>
          Apply
        </Button>
        <Button variant="outlined" color="secondary" onClick={onReset}>
          Reset
        </Button>
      </Box>
    </Box>
  );
};

export default ProposalFilterSidebar;
